import React from 'react';
import Autocomplete from '@mui/joy/Autocomplete';

// Fixed degree lists for the UG/PG Qualification fields.
// Selection-only (no freeSolo) — typing filters this list, but an arbitrary
// value can't be committed, matching the same restriction applied to the
// staff-facing Qualification field in the main vectorindia app.
const UG_QUALIFICATION_OPTIONS = ['B.E.', 'B.Tech', 'B.Sc', 'B.C.A'];
const PG_QUALIFICATION_OPTIONS = ['M.Tech', 'M.E.', 'M.Sc', 'M.C.A', 'M.S'];

export default function QualificationSearch({ value = '', onChange, sx, disabled, required, error, mode = 'ug' }) {
    const options = mode === 'pg' ? PG_QUALIFICATION_OPTIONS : UG_QUALIFICATION_OPTIONS;
    return (
        <Autocomplete
            options={options}
            value={value || null}
            onChange={(_, newValue) => onChange(newValue || '')}
            placeholder="Select qualification"
            disabled={disabled}
            required={required}
            sx={{
                '--Input-radius': '8px',
                '--Input-focusedHighlight': error ? '#ef4444' : '#eb7a24',
                width: '100%',
                fontSize: '0.875rem',
                bgcolor: '#fff',
                ...(error && { boxShadow: 'inset 0 0 0 1.5px #ef4444' }),
                ...sx,
            }}
        />
    );
}
